import { render, staticRenderFns } from "./LoadingSpeedInfoCard.vue?vue&type=template&id=0416b7f3&scoped=true"
import script from "./LoadingSpeedInfoCard.vue?vue&type=script&lang=js"
export * from "./LoadingSpeedInfoCard.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpeedInfoCard.vue?vue&type=style&index=0&id=0416b7f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416b7f3",
  null
  
)

export default component.exports